import { useAuth } from '@/context/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';

export const usePartnerRole = () => {
  const { user, loading: authLoading } = useAuth();

  const { data: isPartner = false, isLoading } = useQuery({
    queryKey: ['partner-role', user?.id],
    queryFn: async () => {
      if (!user) return false;
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .eq('role', 'partner')
        .maybeSingle();
      if (error) {
        console.error('Error checking partner role:', error);
        return false;
      }
      return !!data;
    },
    enabled: !!user && !authLoading,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return { isPartner, loading: authLoading || isLoading };
};
